module.exports = __webpack_public_path__ + "assets/icons/ic_dt_api.svg";